const ja = {
    login: "ログイン",
    logout: "ログアウト",
    signIn: "サインイン",
    signOut: "サインアウト",
    profile: "プロフィール",
    settings: "設定",
    digiAirMenuWaiterLogin: "DigiAirMenu ウェイターログイン",
    username: "ユーザー名",
    password: "パスワード",
    pinCode: "PINコード",
    yourAuthenticationFailed: "認証に失敗しました",
    language: "言語",
    chooseLanguage: "言語を選択",
    pageNotFound: "ページが見つかりません",
    backToDashboard: "ダッシュボードに戻る",
    currentTable: "現在のテーブル",
    table: "テーブル",
    tables: "テーブル一覧",
    order: "注文",
    orders: "注文一覧",
    option: "オプション",
    additive: "追加",
    options: "オプション",
    additives: "追加項目",
    empty: "空",
    untitledItem: "無題",
    createdAt: "作成日時",
    free: "無料",
    items: "項目",
    item: "項目",
    itemsCountOfAll: "{{maxCount}}中{{payCount}}",
    minimum: "最小",
    maximum: "最大",
    all: "すべて",
    unitPrice: "単価",
    email: "メール",
    print: "印刷",
    printingFailed: "印刷に失敗しました",
    orderDetails: "注文詳細",
    noOrders: "注文はありません",
    noOrdersAdded: "追加された注文はありません",
    noAddedItems: "追加された項目はありません",
    loading: "読み込み中",
    createOrSelectOrderAfterSelectingTable: "まずテーブルを選択し、その後で注文を作成または選択してください",
    createOrSelectOrderFirst: "まず注文を作成または選択してください",
    customFood: "カスタム項目",
    customFoods: "カスタム項目",
    normalFoodOrDrink: "通常の料理/ドリンク",
    sentToKitchen: "キッチンに送信済み",
    sendToKitchen: "キッチンへ送る",
    orderDelivered: "注文を受け渡し済み",
    type: "種類",
    status: "ステータス",
    paid: "支払い済み",
    partiallyPaid: "一部支払い済み",
    unpaid: "未払い",
    pending: "保留中",
    canceled: "キャンセル済み",
    created: "作成済み",
    accepted: "受付済み",
    completed: "完了",
    total: "合計",
    editOrderItem: "注文項目を編集",
    chooseTable: "テーブルを選択",
    pickup: "店頭受取",
    suspended: "保留",
    processing: "調理中",
    rejected: "拒否済み",
    delivered: "配達済み",
    ordersList: "注文一覧",
    showOlderOrders: "以前の注文を表示",
    showHistory: "履歴を表示",
    showCanceledOrders: "キャンセル注文を表示",
    showDeliveredOrders: "受け渡し済み注文を表示",
    showPaidOrders: "支払い済み注文を表示",
    addNewOrder: "新しい注文を追加",
    ordering: "注文登録",
    availableFoods: "利用可能な項目",
    searchByTableName: "テーブル名で検索",
    gridView: "グリッド表示",
    listView: "リスト表示",
    Filters: "フィルター",
    availableItems: "利用可能な項目",
    searchByFoodName: "料理名で検索",
    allCategories: "すべてのカテゴリ",
    noCategories: "カテゴリなし",
    addFood: "項目を追加",
    editManualItem: "手動項目を編集",
    addManualItem: "手動項目を追加",
    manualItem: "手動項目",
    manualItems: "手動項目",
    sendEmail: "メール送信",
    send: "送信",
    resendPaymentLink: "支払いリンクを再送信",
    iUnderstand: "わかりました",
    no: "いいえ",
    yes: "はい",
    cancel: "キャンセル",
    close: "閉じる",
    back: "戻る",
    next: "次へ",
    previous: "前へ",
    add: "追加",
    preview: "プレビュー",
    changeTable: "テーブル変更",
    saveChanges: "変更を保存",
    confirm: "確定",
    selectAll: "すべて選択",
    unselectAll: "すべて解除",
    clear: "クリア",
    accept: "受付",
    acceptOrder: "注文を受け付ける",
    confirmOrder: "注文を確定する",
    rejectOrder: "注文を拒否する",
    pay: "会計",
    payment: "支払い",
    payments: "支払い一覧",
    paymentOf: "支払い対象",
    itemsToPay: "会計対象項目",
    price: "価格",
    totalPrice: "合計金額",
    discount: "値引き",
    tip: "チップ",
    payByCreditCard: "クレジットカードで支払う",
    payInCash: "現金で支払う",
    checkout: "会計",
    transaction: "取引",
    transactionDetails: "取引詳細",
    paymentType: "支払い方法",
    paymentStatus: "支払い状況",
    totalAmount: "総額",
    openPayments: "未処理の支払い",
    openPaymentsReport: "未処理支払いレポート",
    thisItemPaymentIsAwaitingConfirmation: "この項目の支払いは確認待ちです",
    yourOrderPaymentIsAwaitingConfirmation: "この注文には確認待ちの支払いがあります",
    editableInTime: "{{minutes}}分{{seconds}}秒後に編集できます",
    generalSettings: "一般設定",
    printMethod: "印刷方法",
    printMethodBrowser: "ブラウザ印刷ダイアログ",
    printMethodBluetooth: "Bluetoothプリンター",
    printMethodUsb: "USBプリンター（試験運用）",
    printMethodExternal: "外部プリンター / アプリ",
    autoPrint: "自動印刷",
    virtualKeyboard: "仮想キーボード",
    delivery: "配達",
    deliveryAddress: "配達先住所",
    deliveryDetails: "配達詳細",
    addDeliveryDetails: "配達詳細を追加",
    editDeliveryDetails: "配達詳細を編集",
    createDelivery: "配達を作成",
    fullAddress: "住所",
    postalCode: "郵便番号",
    houseNumber: "番地",
    doorNumber: "部屋番号",
    floor: "階",
    fullName: "氏名",
    phoneNumber: "電話番号",
    deliverySummary: "配達概要",
    Error: "エラー",
    unexpectedErrorOccurred: "エラーが発生しました",
    distance: "距離",
    duration: "所要時間",
    minutes: "分",
    deliveryPrice: "配達料金",
    deliveryFee: "配達手数料",
    itemsPrice: "商品金額",
    totalReceipt: "レシート合計",
    customer: "顧客",
    pickupDetails: "受取詳細",
    pickupDate: "受取日",
    pickupTime: "受取時間",
    orderId: "注文ID",
    orderStatus: "注文ステータス",
    waiter: "ウェイター",
    fromCustomerApp: "顧客アプリから",
    orderType: "注文タイプ",
    sendDelivery: "配達を送信",
    requestCourier: "配達員を依頼",
    callCourier: "配達員に電話",
    somethingWentWrong: "問題が発生しました",

    appLogoAlt: "digiAirMenu ロゴ",
    addDAMToHomeScreen: "DigiAirMenu をホーム画面に追加",
    addToHomeScreen: "ホーム画面に追加",
    installDAM: "DAM をインストール",
    transferToDemo: "デモへ切り替え",
    transferToLive: "本番へ切り替え",
    row: "行",
    count: "数量",
    step: "ステップ",
    title: "タイトル",
    freeItems: "無料項目",
    min: "最小",
    max: "最大",
    checkoutPrintDataUnavailable: "支払いレシートのデータを印刷できません",
    printUsingExternalDevice: "外部デバイスで印刷",
    customMenuItems: "カスタムメニュー項目",
    orderDeliveredConfirmation: "この注文は受け渡し済みで間違いありませんか？",
    selectItemsForSendingToKitchen: "キッチンへ送る項目を選択",
    ItemDetailsAndStatus: "項目詳細 / ステータス",
    description: "説明",
    typeAnythingYouNeed: "必要な内容を入力してください",
    arrival: "到着",
    late_arrival: "到着遅延",
    late_pickup: "受取遅延",
    request_new_driver: "新しい配達員を依頼",
    shipment_destroyed: "配送品破損",
    address_not_found: "住所が見つかりません",
    late_completed: "遅れて完了",
    isPaid: "支払い済み",
    listOfOrders: "注文リスト",
    listOfolderOrRejectedOrdersTitle: "過去 / 拒否",
    Layout: "レイアウト",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "注文 <1>{{orderId}}</1> をデモ注文に変換してもよろしいですか？",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "注文 <1>{{orderId}}</1> を本番注文に変換してもよろしいですか？",
    areYouSureYouWantToSwitchToLiveMode: "本番モードに切り替えてもよろしいですか？",
    areYouSureYouWantToSwitchToDemoMode: "デモモードに切り替えてもよろしいですか？",
    areYouWantDeleteThisItem: "この項目を削除してもよろしいですか？",
    areYouWantCancelOrder: "この注文をキャンセルしてもよろしいですか？",
    getEmailLabel: "メールアドレスを入力してください",
    enterValidEmailErr: "有効なメールアドレスを入力してください。",
    sendReceiptInfo: "レシート詳細を送信",
    sendMenuSms: "メニューリンクを送信",
    sendMenuLinkBySms: "SMSでメニューリンクを送信",
    menuLinkSentSuccessfully: "メニューリンクを送信しました",
    paymentLinkResentSuccessfully: "支払いリンクを送信しました",
    receiverEmail: "受信者メール",
    receiverPhone: "受信者電話番号",
    receiverEmailPlaceholder: "example@email.com",
    emailIsRequired: "メールは必須です",
    phoneNumberIsRequired: "電話番号は必須です",
    emailOrPhoneIsRequired: "メールまたは電話番号が必要です",
    invalidEmailFormat: "メール形式が正しくありません",
    selected: "選択済み",
    reset: "リセット",
    mobileKeyboard: "モバイルキーボード",
    externalDeliveryOrder: "外部配達注文",
    externalDeliveryOrderDescription: "この注文は処理前に受付が必要です",
    waiterDraftOrder: "ウェイター作成注文",
    waiterDraftOrderDescription: "この注文はまだ編集できます。内容が確定したら確認してください。",
    completeOrderSetup: "注文設定を完了",
    completeOrderSetupDialogTitle: "配達詳細を入力し、注文時間を確定してください",
    acceptOrderDialogTitle: "この注文を受け付けると調理が開始され、キッチンに通知されます",
    confirmOrderDialogTitle: "この注文を確定すると変更がロックされ、調理が開始されます",
    acceptOrderExternalDescription: "この注文は外部から入りました。調理を開始するには受け付け、対応できない場合は拒否してください。",
    confirmOrderWaiterCreatedDescription: "この注文はウェイターが作成しました。すべての項目が準備できたら確認して確定してください。",
    acceptOrderWaiterCreatedDescription: "この注文はウェイターが作成しました。変更をロックして調理を開始するには受け付けてください。",
    editingLockedForCustomerOrder: "顧客注文は編集できません。",
    editingLockedForRejectedOrder: "この注文は拒否されたため編集できません。",
    editingLockedCustomerOrderAfterAcceptance: "顧客注文は受付後に編集できなくなります。",
    editingLockedAfterConfirmation: "注文確定後は編集できません。",
    editingDoneOrderItemLocked: "完了済みの項目は変更できません。",
    editingPaidOrderItemLocked: "支払い済みの項目は変更できません。",
    editingPendingPaymentOrderItemLocked: "支払い処理中のため、この項目は変更できません。",
    editingSentToKitchenItemLockedByPermission: "キッチンへ送信済みの項目を変更する権限がありません。",
    rejectOrderConfirm: "この注文を拒否してもよろしいですか？",
    acceptOrderPickupTimeHelperText: "受取時間は最大 <1>30分</1> 遅らせることができます",
    pleaseEnterPickupTime: "受取時間を入力してください",
    addToOrders: "注文に追加",
    cancelThisOrder: "この注文をキャンセル",
    cancelOrder: "注文をキャンセル",
    orderModeChangedToDemoInJSX: "対象注文モードが '<1>注文 {{targetOrderId}}</1>' のデモモードに変更されました。",
    orderModeChangedToLiveInJSX: "対象注文モードが '<1>注文 {{targetOrderId}}</1>' の本番モードに変更されました。",
    checkoutHasPaidByPosInJSX: "<1>会計</1> id <3>{{checkout_id}}</3> は <5>注文 {{order_id}}</5> から POS で正常に支払われました。",
    demo: "デモ",
    demoModeIsActive: "デモモードが有効です",
    demoModeAlertMessage: "デモモードは、トレーニングおよびテスト目的のみに使用されます。デモモードが有効になっている間、システムの使用および適用されるすべての法令遵守については、レストラン運営者が単独で責任を負います。",
    normal: "通常",
    showOrderInTargetMode: "{{targetMode}} モードで注文を表示",
    showOrder: "注文を表示",
    openOrderInBackground: "<0>開く</0> <1>（バックグラウンド）</1>",
    incomingOrderNotificationTitle: "新しい注文を受信しました",
    incomingOrderNotificationDescription: "顧客注文が届きました。下のボタンで、この画面を閉じずにバックグラウンドで開けます。",
    yesDeleteIt: "はい、削除",
    payReport: "支払いレポート",
    checkoutOperation: "会計操作",
    basicPrice: "基本価格",
    baseAmount: "基本金額",
    paidPrice: "支払い済み金額",
    paidBy: "支払者",
    discountAmount: "値引き額",
    tipPrice: "チップ額",
    totalWithTip: "チップ込み合計",
    amountToPay: "支払う金額",
    paymentAmount: "支払額",
    paymentsIncludingDiscounts: "値引き込みの支払い",
    paymentsExcludingDiscounts: "値引きを除いた支払い",
    paymentsTakingIntoAccountTheirDiscount: "値引きを考慮した支払い",
    paymentsRegardlessOfTheirDiscount: "値引きを考慮しない支払い",
    openPaymentsStatistics: "未処理支払いの統計",
    discountCannotBeLessThanZero: '値引き額は "0" 未満にできません',
    discountCannotBeNegative: "値引き額はマイナスにできません",
    discountCannotBeMoreThanHundredPercent: '値引き額は "100%" を超えられません',
    discountCannotBeMoreThan: "値引き額は {{price}} を超えられません",
    theValueMustBeMoreThan: "値は {{price}} より大きくしてください",
    theValueMustBeMoreThanBaseAmount: "値は基本金額より大きくしてください",
    valueMustBeLessThanOrEqualToMessage: "値は {{maxPrice}} 以下にしてください",
    valueMustBeGreaterThanZeroMessage: "値は 0 より大きくしてください",
    tipAmount: "チップ額",
    tipCannotBeNegative: "チップ額はマイナスにできません",
    cardTransfer: "カード送金",
    noTransactionHasBeenMade: "取引はありません",
    backToTransactionsList: "取引一覧に戻る",
    transactionsHistory: "取引履歴",
    transactionId: "取引ID",
    transactionHasBeenSentToYourEmail: "取引情報をメールに送信しました",
    ordersPrice: "注文金額",
    updatedAt: "更新日時",
    fromTime: "開始",
    toTime: "終了",
    backToOrders: "注文に戻る",
    tablesList: "テーブル一覧",
    backToTablesList: "テーブル一覧に戻る",
    showDetails: "詳細を表示",
    receiptDetailsPage: "レシート詳細ページ",
    checkoutQrCodeAlt: "会計QRコード",
    vat: "VAT",
    net: "税抜",
    tax: "税",
    gross: "税込",
    sendingEmailFailed: "メール送信に失敗しました",
    paymentFailed: "支払いに失敗しました",
    Open_Payments: "未処理の支払い",
    report: "レポート",
    openPaymentStatistics: "未処理支払い統計",
    allOrderItemsHaveBeenPaid: "この注文のすべての項目は支払い済みです",
    noItemsHaveBeenAddedInThisOrder: "この注文には項目が追加されていません",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "この項目は POS で支払い済みで、支払い確認待ちです",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "この注文は POS で支払い済みで、支払い確認待ちです",
    customItems: "カスタム項目",
    singlePrintMethodDescription: "同時に有効にできる印刷方法は1つだけです",
    bluetoothUnavailable: "このブラウザまたは端末では Bluetooth を利用できません",
    bluetoothSecureContextRequired: "Bluetooth 印刷には HTTPS または localhost が必要です",
    bluetoothPrinterNotSupported: "選択した Bluetooth プリンターはサポートされていません",
    noBluetoothPrinterSelected: "Bluetooth プリンターが選択されていません",
    noCompatibleBluetoothPrinterFound: "対応する Bluetooth プリンターが見つからないか選択されていません。ブラウザは通常 BLE/GATT プリンターのみ検出するため、Epson TM-m30 のような従来型 Bluetooth モデルは表示されない場合があります",
    bluetoothAutoPrintRequiresSelection: "自動印刷を使用する前に、Bluetooth プリンターを一度手動で選択してください",
    bluetoothPrintingNotSupported: "このブラウザまたは端末では Bluetooth 印刷はサポートされていません",
    usbUnavailable: "このブラウザまたは端末では USB を利用できません",
    usbSecureContextRequired: "USB 印刷には HTTPS または localhost が必要です",
    noCompatibleUsbPrinterFound: "対応する USB プリンターが見つからないか選択されていません",
    usbAccessDenied: "ブラウザまたはOSが選択した USB プリンターへのアクセスを拒否しました。他の印刷アプリを閉じ、システムの USB 権限を確認してから再試行してください",
    usbAutoPrintRequiresSelection: "自動印刷を使用する前に、USB プリンターを一度手動で選択してください",
    usbPrintingNotSupported: "選択した端末では USB 印刷はサポートされていません",
    printerSize: "プリンターサイズ",
    useExternalPrinter: "外部プリンターを使用",
    bluetoothPrinterDetails: "Bluetooth プリンターへ印刷を送信できます。無効にすると、この端末に接続されたプリンターから選択できます",
    usbPrinterDetails: "デスクトップ版 Chrome または Edge で ESC/POS 対応 USB プリンターを試験的にサポートします。自動印刷で使う前に、一度手動でプリンターを選択する必要があります。Windows ではブラウザ一覧に表示するため、Vendor Class モードと WinUSB 対応ドライバーが必要な場合があります",
    externalPrinterDetails: "アプリに接続された外部プリンターへ印刷を送信できます。無効にすると、この端末に接続されたプリンターから選択できます",
    autoPrintDescription: "注文受付後、または支払い済み注文の websocket イベント受信後に自動印刷します",
    autoPrintUnavailableForBrowserDescription: "ブラウザ印刷ダイアログ使用時は自動印刷を利用できません",
    browserPrintMethodNotice: "ブラウザ印刷ダイアログは常に確認が必要なため、レシートは自動印刷できません",
    selectAllPayablesByDefault: "会計対象を初期状態ですべて選択",
    selectAllPayablesByDefaultOnThePaymentPage: "支払いページで会計対象項目を初期状態ですべて選択",
    virtualKeyboardDescription: "対応フォーム項目でアプリ内キーボードを使用",
    virtualKeyboardInfoLabel: "キーボードヘルプ",
    virtualKeyboardDisableHint: "端末のキーボードを使いたい場合は、<0>設定</0>でこのキーボードをオフにできます。",
    served: "提供済み",
    apartmentEntrance: "建物入口",
    extraAddressDetails: "住所補足",
    dialCode: "国番号",
    contactInformationAtPickup: "受取人の連絡先",
    recommended: "推奨",
    successfulDeliveryRegistration: "配達登録が完了しました",
    successfulSendDelivery: "配達を送信しました",
    withDelivery: "配達あり",
    deliveryItem: "配達項目",
    pickupDatetime: "希望受取日時",
    pickupTimeLabel: "受取時間（{{format}}）",
    pickupTimeBaseLabel: "基準受取時間",
    pickupTimeFinalLabel: "最終受取時間",
    dropOffTime: "引き渡し時間",
    requestedPickupDatetime: "現在の希望受取日時",
    timePickerHour: "時",
    timePickerMinute: "分",
    toggleTimeList: "時間リストを切り替え",
    pickupTimeInitialShort: "基準",
    orderTiming: "注文時間",
    maximumSelectableFreeCountHint: "無料で選択できる最大数",
    minimumSelectableCountHint: "選択できる最小数",
    maximumSelectableCountHint: "選択できる最大数",
    maximumSelectedItemsReached: "選択数が上限に達しました",
    changePickupTime: "受取時間を変更",
    pickupTimeAllowedRangeHint: "{{date}} の受取時間は {{start}} から {{end}} の間で選択できます。",
    pickupDatetimeNotSetHint: "受取日時はまだ設定されていません。任意の受取時間を選択できます。",
    pickupDatetimeLimitedDelayHint: "この希望受取日時は、注文が受付待ちの間は最大 <1>30分</1> 遅らせることができます。",
    pickupDatetimeLockedHint: "この注文にはすでに受取日時が設定されています。",
    pickupTimeEditableOnlyWhenSuspended: "受取時間は注文が保留状態のときだけ変更できます。",
    pleaseEnterPickupDate: "受取日を入力してください",
    pickupDateMustBeTodayOrTomorrow: "ウェイター作成注文の受取日は今日または明日である必要があります。",
    normalOrderCreationUnavailableTitle: "通常注文は現在利用できません",
    normalOrderCreationClosedAllDay: "この日はレストランが休業のため、注文を作成できません。",
    normalOrderCreationClosedAtThisTime: "現在レストランは営業時間外です。注文は営業時間内に作成できます: {{hours}}。",
    waiterOrderNoAvailableOpenSlot: "現在許可されている日付では、レストラン営業時間内に有効な {{orderType}} 時間がありません。",
    pickupDateOutsideOpeningHours: "選択した日付は {{orderType}} 注文で許可された営業日の範囲外です。",
    pickupTimeOutsideOpeningHours: "選択した時間は {{orderType}} 注文で許可された営業時間外です。",
    openingHoursSelectableRangeHint: "{{date}} の {{orderType}} 時間は {{start}} から {{end}} の間で選択できます。",
    openingHoursClosedDayHint: "{{date}} は {{orderType}} 注文を受け付けていません。",
    openingHoursClosedDayCalendarHint: "この注文タイプは休止",
    openingHoursDisabledDatesHint: "レストラン営業時間内に {{orderType}} の選択可能な時間が少なくとも1つある日付だけ選択できます。",
    openingHoursUnavailableTimesHint: "選択できない時間は、選択した日付の {{orderType}} 注文向けレストラン営業時間外です。",
    deliveryAndPickupOrders: "配達・店頭受取注文",
    payByLink: "リンクで支払い",
    updateDelivery: "配達を更新",
    sendCourierRequest: "配達員依頼を送信",
    sentToCourier: "配達員へ送信済み",
    noPickupTimeProvidedForThisOrder: "この注文には受取時間が指定されていません",
    pickupTimeCalculationForThisOrderFailed: "この注文の受取時間計算に失敗しました",
    itemEditFailed: "商品の編集に失敗しました",
    thisItemCannotBeEdited: "この商品は編集できません。",
    problemInReadingItemEssentialDataMessage: "商品の必須情報の読み込み中に問題が発生しました",
};

export default ja;
